import { Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import SocialNetworksIcons from './SocialNetworksIcons';
import styleRules from '../styles';

import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => createStyles(styleRules(theme)));

const SocialNetworks: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { socialContainer, socialTitle, typographySecondary, socialLogos } = useStyles();

  return (
    <Grid className={socialContainer}>
      <Grid container item md={12} direction="row" wrap="nowrap" justifyContent="space-between">
        <Grid item className={socialTitle} md={4}>
          <Typography className={typographySecondary}>{t('auth.via.social')}</Typography>
        </Grid>
        <Grid container item className={socialLogos} md={8}>
          <SocialNetworksIcons />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SocialNetworks;
